/**
 * User Login Status Control Component
 * 
 * @package TopBuddy
 */

import { SelectControl } from '@wordpress/components';
import { __ } from '@wordpress/i18n';

const UserLoginStatusControl = ({ value, onChange }) => {
	return (
		<div className="topbuddy-display-rules__field">
			<SelectControl
				label={__('User Login Status', 'topbuddy')}
				help={__('Control who can see this notification bar based on login status', 'topbuddy')}
				value={value}
				onChange={onChange}
				options={[
					{ label: __('Any', 'topbuddy'), value: 'any' },
					{ label: __('Logged In Users Only', 'topbuddy'), value: 'logged_in' },
					{ label: __('Logged Out Users Only', 'topbuddy'), value: 'logged_out' },
				]}
				__next40pxDefaultSize
				__nextHasNoMarginBottom
			/>
		</div>
	);
};

export default UserLoginStatusControl;
